"use client";

import React from "react";
import { Users, Layers, MapPin, Briefcase } from "lucide-react";

export function TeamSplittingScenario() {
    return (
        <div className="w-full space-y-6">
            {/* Current State */}
            <div className="bg-muted/30 border rounded-xl p-4 flex flex-col items-center gap-4 text-center">
                <div className="grid place-items-center h-16 w-16 bg-red-100 dark:bg-red-900/20 rounded-full">
                    <Users className="h-8 w-8 text-red-600 dark:text-red-400" />
                </div>
                <div>
                    <h4 className="font-bold text-lg">Current Team Structure</h4>
                    <p className="text-sm text-muted-foreground">12 Developers • 1 PO • 1 SM</p>
                </div>
                <div className="bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300 px-3 py-1 rounded-full text-xs font-semibold border border-red-200 dark:border-red-900">
                    PROBLEM: "Communication Overhead"
                </div>
            </div>

            {/* Split Options */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="border border-dashed rounded-lg p-4 hover:bg-muted/50 transition-colors cursor-default">
                    <div className="flex flex-col items-center text-center gap-3">
                        <div className="p-2 bg-blue-100 dark:bg-blue-900/20 rounded-full">
                            <Briefcase className="h-5 w-5 text-blue-600 dark:text-blue-400" />
                        </div>
                        <div>
                            <h5 className="font-semibold text-sm">Option A: By Customer</h5>
                            <p className="text-xs text-muted-foreground mt-1">Team "Customer A" <br /> Team "Customer B"</p>
                        </div>
                    </div>
                </div>

                <div className="border border-dashed rounded-lg p-4 hover:bg-muted/50 transition-colors cursor-default">
                    <div className="flex flex-col items-center text-center gap-3">
                        <div className="p-2 bg-purple-100 dark:bg-purple-900/20 rounded-full">
                            <Layers className="h-5 w-5 text-purple-600 dark:text-purple-400" />
                        </div>
                        <div>
                            <h5 className="font-semibold text-sm">Option B: By Tech</h5>
                            <p className="text-xs text-muted-foreground mt-1">Frontend Team <br /> Backend Team</p>
                        </div>
                    </div>
                </div>

                <div className="border border-dashed rounded-lg p-4 hover:bg-muted/50 transition-colors cursor-default">
                    <div className="flex flex-col items-center text-center gap-3">
                        <div className="p-2 bg-orange-100 dark:bg-orange-900/20 rounded-full">
                            <MapPin className="h-5 w-5 text-orange-600 dark:text-orange-400" />
                        </div>
                        <div>
                            <h5 className="font-semibold text-sm">Option C: By Location</h5>
                            <p className="text-xs text-muted-foreground mt-1">Berlin Team <br /> Remote Team</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
